export const itemsTab = [
	{ name: 'Пункты', value: 'points' },
	{ name: 'Таблицы', value: 'tables' },
]
